import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { dre } from '../../interfaces/graficos'
import { dreMes } from '../../services/dashboardFinanceiro'
import LoadingCirculo from '../LoadingCirculo'
import NenhumDadoGrafico from '../NenhumDadoGrafico'
import './dremes.css'

function DreMes () {

    const navigate = useNavigate()

    const [carregando, setCarregando] = useState (true)
    const [grafico, setGrafico] = useState (false)
    const [dados, setDados] = useState<dre>()
    const [lucroMesValor, setLucroMesValor] = useState(0)
    const [semDados, setSemDados] = useState (false)

    useEffect (() => {

        const ticket = async () => {

            try {
                const resposta = await dreMes ()
                setCarregando (false)
                setDados (resposta.data[0])

                if (resposta.data.length === 0) {
                    return setSemDados(true)
                }
                setGrafico (true)

            } catch (error:any) {

                if (error.status === 401) {
                    return navigate('/');
                }
            }
        }

        ticket ()

    }, [navigate])

    useEffect (() => {

        const lucroMes = dados?.faturamento === undefined ? 0: dados.faturamento - dados?.despesas

        return setLucroMesValor(lucroMes)
        
    }, [dados])


    return (
            <div id = 'dreMes'>
                <p id='dreMesP'>DRE DO MÊS</p>
                {carregando && <LoadingCirculo/>}
                {grafico && <section>
                    <span>
                        <p>Faturamento</p>
                        <h1>{dados?.faturamento === undefined ? 'R$ 0,00' : Number(dados.faturamento).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</h1>
                    </span>
                    <span>
                        <p>Depesas</p>
                        <h1>{dados?.despesas === undefined ? 'R$ 0,00' : Number(dados.despesas).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</h1>
                    </span>
                    <span>
                        <p>Lucro</p>
                        <h1>{lucroMesValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</h1>
                    </span>
                </section>}
                {semDados && <NenhumDadoGrafico texto='Sem Dados para' subtexto='exibir o gráfico'/>}
            </div>
    )
}

export default DreMes